function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-hotwater",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "26-desktop-UI-hotwater",
  transform: "translate(-385.000000, -1329.000000)",
  stroke: "#3F5063",
  strokeWidth: 2
}, React.createElement("g", {
  id: "temperature-2-hotwater",
  transform: "translate(386.000000, 1330.000000)"
}, React.createElement("path", {
  d: "M39.25,27.1575 L39.25,7.715 C39.25,3.84900675 36.1159932,0.715 32.25,0.715 C28.3840068,0.715 25.25,3.84900675 25.25,7.715 L25.25,27.1575 C19.7624478,30.3257397 17.0870369,36.7847531 18.7270384,42.9053223 C20.36704,49.0258915 25.9135205,53.2818557 32.25,53.2818557 C38.5864795,53.2818557 44.13296,49.0258915 45.7729616,42.9053223 C47.4129631,36.7847531 44.7375522,30.3257397 39.25,27.1575 Z",
  id: "Path-hotwater"
}), React.createElement("circle", {
  id: "Oval-hotwater",
  cx: 32.25,
  cy: 39.215,
  r: 7
}), React.createElement("path", {
  d: "M32.25,14.715 L32.25,32.215",
  id: "Path-hotwater"
}), React.createElement("path", {
  d: "M0.75,4.25 L14.75,4.25",
  id: "Path-hotwater"
}), React.createElement("path", {
  d: "M7.75,14.75 L14.75,14.75",
  id: "Path-hotwater"
}), React.createElement("path", {
  d: "M0.75,25.25 L14.75,25.25",
  id: "Path-hotwater"
}))));

var SvgHotWater = function SvgHotWater(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "49px",
    height: "62px",
    viewBox: "0 0 49 56",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHotWater, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hotWater.e1a9fcf1.svg";
export { ForwardRef as ReactComponent };